import { ListaPrecoTabela } from './../../../../../shared/interfaces/lista-preco-tabela';
import { Parameters } from './../../../../../shared/interfaces/parameters';
import { ListaPreco } from 'app/shared/interfaces/lista-preco';
import { Preco } from 'app/shared/interfaces/preco';
import { CopiaPrecoItem } from 'app/shared/interfaces/copia-preco-item';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ListaPrecoService } from 'app/shared/services/lista-preco.service';
import { ListaPrecoTabelaService } from 'app/shared/services/lista-preco-tabela.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-produto-preco-edit-popup',
  templateUrl: './produto-preco-edit-popup.component.html',
  styleUrls: ['./produto-preco-edit-popup.component.scss'],
  providers: [

    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProdutoPrecoEditPopupComponent implements OnInit {

  produtoPrecoForm: FormGroup;
  preco: Preco;
  precos: Preco[];
  layoutConf: any;
  startDate = new Date();

   /**
  * Ao Teclar Esc
  */
    // @HostListener('window:keyup.esc') onKeyUp() {
    //   if (this.dialog.openDialogs.length > 0 ) {
    //     console.log('@HostListener(window:keyup.esc) onKeyUp()');
    //     this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //       .subscribe(res => {
    //         if (res) {

    //           this.dialogRef.close();
    //         }
    //       });
    //   }
    // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoPrecoEditPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private listaPrecoService: ListaPrecoService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.preco = this.data.payload;
    console.log(`preco >>>>>>>>> ${JSON.stringify(this.preco)} `);
    
    console.log(`Produto: ${JSON.stringify(this.preco.listaPreco.id)} - ${JSON.stringify(this.preco.tabela)}`);
    this.buildProdutoPrecoForm(this.preco)

    console.log(`produtoPrecoForm >>>> ${JSON.stringify(this.produtoPrecoForm.value)}`);
    

  }

  buildProdutoPrecoForm(preco: Preco) {
    this.produtoPrecoForm = this.fb.group({
      produtoId: [preco?.produtoId],
      listaId: [preco?.listaId],
      tabelaId: [preco?.tabelaId],
      preco: [preco.preco],
      precoPromocao: [preco.precoPromocao],
      validadePromocao: [preco.validadePromocao],
      saldo: [preco.saldo],
      tabelaDesc: [preco.tabelaDesc],
      listaDesc: [preco.listaDesc],
      percentualAcrescimo: [preco.percentualAcrescimo],
      percentualDesc: [preco.percentualDesc],
      observacao: [preco.observacao],
      listaPreco: [preco.listaPreco],
      tabela: [preco.tabela],
      produtoUuid: [],
    })

  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  submit() {
    if (this.produtoPrecoForm.valid) {
      console.log('form submitted');
      this.save();
    } else {
      this.validateAllFormFields(this.produtoPrecoForm); // {7}
    }
  }

  save(){
    // this.produtoPrecoForm.patchValue({ preco: this.produtoPrecoForm['preco'] });
    // this.produtoPrecoForm.patchValue({ percentualDesc: this.produtoPrecoForm['percentualDesc'] });
    // this.produtoPrecoForm.patchValue({ precoPromocao: this.produtoPrecoForm['precoPromocao'] });
    // this.produtoPrecoForm.patchValue({ validadePromocao: this.produtoPrecoForm['validadePromocao']?.toISOString()?.slice(0, 19) });
    // this.produtoPrecoForm.patchValue({ observacao: this.produtoPrecoForm['observacao'] });
   
    this.precos = [];
    this.precos.push(this.produtoPrecoForm.value);

    console.log(`preco >>>>> ${JSON.stringify(this.precos)}`);

    // 1) Grava o preço editado (com todos os campos: promoção/desconto/observação).
    this.produtoService.saveOrUpdatePrecos(this.precos).subscribe(
      (precos) => {
        const v = this.produtoPrecoForm.value;
        const tabelaId = v.tabelaId ?? v.tabela?.id?.tabelaId;
        const listaId = v.listaId ?? v.listaPreco?.id;

        // 2) Cascata: ao alterar a TABELA BASE (tabela 1), propaga o preço para as tabelas
        // SEGUINTES com fator+índice (mesma regra do desktop), via POST /produto/preco/copia-tabela
        // (backend copiarComFatores: base + cascata + completude das tabelas com fator/índice).
        if (Number(tabelaId) === 1) {
          const item: CopiaPrecoItem = {
            produtoId: v.produtoId,
            precoBase: Number(v.preco),
            listaId: listaId,
            tabelaId: tabelaId,
          };
          this.produtoService.copiaTabelaPreco([item]).subscribe(
            () => {
              this.confirmService.confirm({
                title: `S U C E S S O  !`,
                message: `Preço atualizado e propagado às tabelas seguintes (fator/índice) com sucesso!`,
                error: false,
              });
            },
            (err) => {
              this.confirmService.confirm({
                title: `A T E N Ç Ã O !`,
                message: `Preço salvo, mas não foi possível propagar às tabelas seguintes.`,
                error: true,
              });
            }
          );
        } else {
          this.confirmService.confirm({
            title: `S U C E S S O  !`,
            message: `Preco Atualizado com Sucesso !`,
            error: false,
          });
        }
      },
      (err) => {

        this.confirmService.confirm(
          {
            title: `A T E N Ç Ã O !`,
            message: `Não foi Possível Atualizar Preço!`,
            error: true
          }
        );
      });

  }

  close() {
    this.dialogRef.close();
  }

}
